import React from 'react';
import { StyleSheet, View } from 'react-native';

import { useResponsive } from '../../../../../hooks';
import { type Props } from './NoticeBannersStackWrapper.types';

// ────────────────────────────────────────────────────────────────────────────────

export const NoticeBannersStackWrapper = (props: Props) => {
  const { style, children, ...restProps } = props;

  const { match } = useResponsive();

  return (
    <View
      style={[style, match([styles.wrapperXs, undefined])]}
      pointerEvents="none"
      {...restProps}
    >
      {children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapperXs: {
    flexDirection: 'column-reverse',
  },
});
